/* Merchant delivery estimates. First matching range wins. Working days, not a courier coverage guarantee. */
window.AGPinRules={
  "defaultRange": [
    4,
    6
  ],
  "ranges": [
    {
      "fromPin": 180001,
      "toPin": 194999,
      "area": "remote",
      "min": 5,
      "max": 7,
      "name": "Jammu & Kashmir / Ladakh"
    },
    {
      "fromPin": 244712,
      "toPin": 263999,
      "area": "remote",
      "min": 5,
      "max": 7,
      "name": "Uttarakhand"
    },
    {
      "fromPin": 781001,
      "toPin": 799999,
      "area": "remote",
      "min": 5,
      "max": 7,
      "name": "Northeast India"
    },
    {
      "fromPin": 110001,
      "toPin": 110099,
      "area": "metro",
      "min": 3,
      "max": 4,
      "name": "Delhi"
    },
    {
      "fromPin": 400001,
      "toPin": 400104,
      "area": "metro",
      "min": 3,
      "max": 4,
      "name": "Mumbai"
    },
    {
      "fromPin": 560001,
      "toPin": 560110,
      "area": "metro",
      "min": 3,
      "max": 4,
      "name": "Bengaluru"
    },
    {
      "fromPin": 600001,
      "toPin": 600130,
      "area": "metro",
      "min": 3,
      "max": 4,
      "name": "Chennai"
    },
    {
      "fromPin": 500001,
      "toPin": 500100,
      "area": "metro",
      "min": 3,
      "max": 4,
      "name": "Hyderabad"
    },
    {
      "fromPin": 700001,
      "toPin": 700160,
      "area": "metro",
      "min": 3,
      "max": 4,
      "name": "Kolkata"
    },
    {
      "fromPin": 411001,
      "toPin": 411060,
      "area": "metro",
      "min": 3,
      "max": 4,
      "name": "Pune"
    },
    {
      "fromPin": 682001,
      "toPin": 682050,
      "area": "metro",
      "min": 3,
      "max": 4,
      "name": "Kochi"
    },
    {
      "fromPin": 380001,
      "toPin": 380060,
      "area": "city",
      "min": 3,
      "max": 5,
      "name": "Ahmedabad"
    },
    {
      "fromPin": 395001,
      "toPin": 395030,
      "area": "city",
      "min": 3,
      "max": 5,
      "name": "Surat"
    },
    {
      "fromPin": 302001,
      "toPin": 302040,
      "area": "city",
      "min": 3,
      "max": 5,
      "name": "Jaipur"
    },
    {
      "fromPin": 226001,
      "toPin": 226050,
      "area": "city",
      "min": 3,
      "max": 5,
      "name": "Lucknow"
    },
    {
      "fromPin": 160001,
      "toPin": 160050,
      "area": "city",
      "min": 3,
      "max": 5,
      "name": "Chandigarh"
    },
    {
      "fromPin": 641001,
      "toPin": 641050,
      "area": "city",
      "min": 3,
      "max": 5,
      "name": "Coimbatore"
    },
    {
      "fromPin": 673001,
      "toPin": 673050,
      "area": "city",
      "min": 3,
      "max": 5,
      "name": "Kozhikode"
    },
    {
      "fromPin": 695001,
      "toPin": 695050,
      "area": "city",
      "min": 3,
      "max": 5,
      "name": "Thiruvananthapuram"
    },
    {
      "fromPin": 686001,
      "toPin": 686050,
      "area": "town",
      "min": 4,
      "max": 5,
      "name": "Kottayam"
    },
    {
      "fromPin": 680001,
      "toPin": 680050,
      "area": "town",
      "min": 4,
      "max": 5,
      "name": "Thrissur"
    },
    {
      "fromPin": 670001,
      "toPin": 670050,
      "area": "town",
      "min": 4,
      "max": 5,
      "name": "Kannur"
    }
  ]
};
